import moment from 'moment';
import config from '../../config';

export const timeOptions = (() => {
  const options = [];
  const interval = moment.duration(30, 'minutes');
  const end = moment
    .utc()
    .startOf('day')
    .add(1, 'day');
  const time = moment.utc().startOf('day');
  while (time.isBefore(end)) {
    options.push({
      value: time.format(config.timeFormatFull),
      label: time.format(config.timeFormat),
    });
    time.add(interval);
  }
  return options;
})();

export const getNextGivenWeekdayOfType = (day) => {
  const intDay = parseInt(day, 10);

  if (moment().isoWeekday() <= intDay) {
    return moment().isoWeekday(intDay);
  }
  return moment().add(1, 'weeks').isoWeekday(intDay);
};
